import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';

@Component({
  selector: 'app-products-history',
  templateUrl: './products-history.component.html',
  styleUrls: ['./products-history.component.scss']
})
export class ProductsHistoryComponent extends DialogBase implements OnInit {
  title: any;
  product: any;
  productHistoryList: any[] = [];

  ngOnInit(): void {
    this.getProductHistory();
  }

  getProductHistory() {
    this.spinnerService.start();
    this.apiService.product.getProductHistory(this.product)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.productHistoryList = res;
      }, err => {
        Utils.showError(err);
      })
  }
}
